import { LOCATION_CHANGE } from 'connected-react-router'
import at from '../redux/actionTypes'
import voteTypes from '../enums/voteTypes'

const ITEMKEY_NOT_FOUND = 'ITEMKEY_NOT_FOUND'
const POSTID_NOT_FOUND = 'POSTID_NOT_FOUND'
const KITID_NOT_FOUND = 'KITID_NOT_FOUND'

//	Note - we're formatting these events for GA - ref: https://developers.google.com/analytics/devguides/collection/analyticsjs/events
//	ie: category, action, label, value - though of course they're able to also be interpreted by other targets.
const eventsMap = (trackPage, trackEvent) => ({
	[LOCATION_CHANGE]: trackPage(action => ({ page: action.payload.location.pathname })),
	[at.buyButtonClick]: trackEvent((action) => {
		const buyClick = action.payload.buyClick || {}
		return {
			category: at.buyButtonClick,
			action: buyClick.itemKey,
			label: buyClick.brand
		}
	}),
	[at.itemOwnSet]: trackEvent((action) => {
		const payload = action.payload || {}
		return {
			category: at.itemOwnSet,
			action: payload.item ? payload.item.itemKey : ITEMKEY_NOT_FOUND,
			label: payload.own
		}
	}),
	[at.itemWantSet]: trackEvent((action) => {
		const payload = action.payload || {}
		return {
			category: at.itemWantSet,
			action: payload.item ? payload.item.itemKey : ITEMKEY_NOT_FOUND,
			label: payload.want
		}
	}),
	[at.kitOwnSet]: trackEvent((action) => {
		const payload = action.payload || {}
		return {
			category: at.kitOwnSet,
			action: payload.kit ? payload.kit.kitId : KITID_NOT_FOUND,
			label: payload.own
		}
	}),
	[at.kitWantSet]: trackEvent((action) => {
		const payload = action.payload || {}
		return {
			category: at.kitWantSet,
			action: payload.kit ? payload.kit.kitId : KITID_NOT_FOUND,
			label: payload.want
		}
	}),
	[at.kitSuggestionSet]: trackEvent((action, prevState, nextState) => {
		const payload = action.payload || {}
		return {
			category: at.kitSuggestionSet,
			action: nextState.kit ? nextState.kit.kitId : KITID_NOT_FOUND,
			value: payload.kitSuggestion ? payload.kitSuggestion.length : 0
		}
	}),
	[at.ITEM_FEATURE_VOTE]: trackEvent((action, prevState, nextState) => {
		const payload = action.payload || { vote: {} }
		let value = payload.vote.type === voteTypes.UP.type ? 1 : 0
		if (payload.vote.type === voteTypes.DOWN.type) {
			value = -1
		}
		return {
			category: at.ITEM_FEATURE_VOTE,
			action: nextState.item ? nextState.item.itemKey : ITEMKEY_NOT_FOUND,
			label: payload.featureType,
			value
		}
	}),
	[at.postDelete]: trackEvent((action) => {
		const payload = action.payload || {}
		return {
			category: at.postDelete,
			action: payload.postId || POSTID_NOT_FOUND
		}
	}),
	[at.kitDelete]: trackEvent((action) => {
		const payload = action.payload || {}
		return {
			category: at.kitDelete,
			action: payload.kitId || KITID_NOT_FOUND
		}
	}),
	[at.kitSet]: trackEvent((action) => {
		const payload = action.payload || {}
		return {
			category: at.kitSet,
			action: payload.kitId || KITID_NOT_FOUND
		}
	}),
	[at.kitDuplicate]: trackEvent((action) => {
		const payload = action.payload || {}
		return {
			category: at.kitDuplicate,
			action: payload.kitId || KITID_NOT_FOUND
		}
	}),
	[at.postSet]: trackEvent((action) => {
		const payload = action.payload || {}
		return {
			category: at.postSet,
			action: payload.postId || POSTID_NOT_FOUND
		}
	}),
	[at.AUTH_LOGOUT]: trackEvent(() => ({
		category: at.AUTH_LOGOUT,
		action: 'click'
	})),
	[at.AUTH_LOGIN_SUCCESS]: trackEvent(() => ({
		category: at.AUTH_LOGIN_SUCCESS,
		action: 'click'
	})),
	[at.searchTypeSet]: trackEvent((action) => {
		const payload = action.payload || {}
		return {
			category: at.searchTypeSet,
			action: payload.searchType
		}
	}),
	[at.searchItem]: trackEvent((action, prevState, nextState) => {
		const payload = action.payload || {}
		return {
			category: at.searchItem,
			action: payload.query,
			label: nextState.searchType
		}
	}),
	[at.searchUser]: trackEvent((action, prevState, nextState) => {
		const payload = action.payload || {}
		return {
			category: at.searchUser,
			action: payload.query,
			label: nextState.searchType
		}
	}),
	[at.searchKit]: trackEvent((action, prevState, nextState) => {
		const payload = action.payload || {}
		return {
			category: at.searchKit,
			action: payload.query,
			label: nextState.searchType
		}
	}),
	[at.userProfileFollowersSet]: trackEvent((action) => {
		const payload = action.payload || {}
		return {
			category: at.userProfileFollowersSet,
			action: payload.isFollowing,
			label: payload.uid
		}
	}),
	[at.userProfileFollowingRemove]: trackEvent((action) => {
		const payload = action.payload || {}
		return {
			category: at.userProfileFollowingRemove,
			action: payload.isFollowing,
			label: payload.uid
		}
	}),
	[at.userProfileFollowerRemove]: trackEvent((action) => {
		const payload = action.payload || {}
		return {
			category: at.userProfileFollowerRemove,
			action: payload.isFollowing,
			label: payload.uid
		}
	}),
	[at.userProfileVerifiersSet]: trackEvent((action) => {
		const payload = action.payload || {}
		return {
			category: at.userProfileVerifiersSet,
			action: payload.hasVerified,
			label: payload.uid
		}
	}),
	[at.userProfileUpdate]: trackEvent(() => ({
		category: at.userProfileUpdate,
		action: 'click'
	}))
})

export default eventsMap



// WEBPACK FOOTER //
// ./src/analytics/eventsMap.js